import { Circle, File, MessageCircle, Terminal } from "react-feather";
import { getUserData} from "../../utility/Utils";


const ApiGateway = [{
    id:"api_gateway",
    title:"API",
    icon:<Terminal size={20}/>,
    navLink:"/api-gateway"
}]

const ApiGate = ApiGateway
export default ApiGate